import type { ReactElement } from 'react';
import { useState } from 'react';

import Address from 'models/Address';
import { NotificationType } from 'models/Notifications';
import type { INotification } from 'models/Notifications';

import useNotifications from 'hooks/useNotifications';
import { getQueryParam } from 'utils/location';

import { Component as PlusIcon } from 'icons/icon-ui--plus.svg';
import AddressModal from 'components/shared/modals/AddressModal';

type Props = {
  isHidden: boolean;
  onAdd: (address: Address) => void;
};

function AddAddressCard({ isHidden, onAdd }: Props): ReactElement {
  const { dispatch } = useNotifications();
  const [showAddressModal, setShowAddressModal] = useState(getQueryParam('add') === 'address');

  const handleCloseAddressModal = (address) => {
    setShowAddressModal(false);
    if (address) onAdd(address);

    dispatch({
      type: 'addNotification',
      notification: {
        id: address.id,
        notification_type: NotificationType.ADDRESS_CHANGE,
        operation: 'ADD',
      } as INotification,
    });
  };

  return (
    <div
      className={[
        'col-12',
        'col-sm-6',
        'col-lg-4',
        'c-profile__address-item',
        'd-mapp-none',
        isHidden ? 'd-none' : '',
      ].join(' ')}
    >
      <button
        type="button"
        className="c-add-address-link"
        onClick={() => setShowAddressModal(true)}
      >
        <div className="c-add-address-link__content">
          <PlusIcon height="21" width="21" />
          <span className="d-block">Add Address</span>
        </div>
      </button>

      {showAddressModal && (
        <AddressModal
          isPrimaryEditable
          onClose={handleCloseAddressModal}
        />
      )}
    </div>
  );
}

export default AddAddressCard;
